import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const assistantActions = createActionGroup({
  source: 'Einreichung Assistant',
  events: {
    'Navigate to step by index': props<{ index: number }>(),
    'Navigate to next step': emptyProps(),
    'Navigate to previous step': emptyProps(),
    'Reset step index': emptyProps(),
    'Select container': props<{ selectedContainerId: string }>(),
    'Set data privacy accepted': props<{ accepted: boolean }>(),
    'Close assistant': emptyProps(),
    'Clear store': emptyProps(),
  },
});
